import { RouterModule, Routes } from '@angular/router';
import { SampleLayoutComponent } from './containers/sample-layout/sample-layout';
import { GridPageComponent } from './containers/grid-page/grid-page';
import { DemoPageComponent } from './containers/demo-page/demo-page';
import { DbPageComponent } from './containers/db-page/db-page';
import { WelcomePageComponent } from './containers/welcome-page/welcome-page';


const routes: Routes = [
  {
    path: 'sample',
    component: SampleLayoutComponent,
    // canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/sample/welcome', pathMatch: 'full' },
      { path: 'welcome', component: WelcomePageComponent },
      { path: 'demo', component: DemoPageComponent },
      { path: 'grid', component: GridPageComponent },
      { path: 'db', component: DbPageComponent },
    ]
  }
];


export const SampleRoutingModule = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/sample-routing.module.ts